import React from 'react';
import { Seo } from 'components/seo/seo';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { MasterPage } from '../master-page/master.page';
import { NOT_FOUND_404 } from '../../assets/images/images';
import { useDispatch } from 'react-redux';
import { Button } from 'antd';
import { navigationSlice } from 'logic/store/navigation/navigation.slice';
import { AppRoute } from 'app/app.route.const';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
`;

const Img = styled.img`
  max-width: 100%;
  margin-bottom: 1rem;
`;

const NotFoundPage: React.FC = () => {
  const dispatch = useDispatch();

  return (
    <MasterPage>
      <Seo noIndex />
      <Container>
        <Img src={NOT_FOUND_404} alt={''} />
        <Button
          type={'primary'}
          onClick={() => dispatch(navigationSlice.actions.navigateTo({ path: AppRoute.Home }))}
        >
          {translate(translationKeys.notFoundPage.backToHomepage)}
        </Button>
      </Container>
    </MasterPage>
  );
};
export default NotFoundPage;
